export const apiURL = (path: string): string => {
  return `${process.env.REACT_APP_API_URL}/${path}`;
};

export const streamURL = (path: string): string => {
  const base = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
  if (base.startsWith("http")) {
    return `${base}/${path}`;
  }
  return `${window.location.protocol}//${base}/${path}`;
};
